import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { IconClose } from "icons";
import { ImageFeatureAnnouncement1, ImageFeatureAnnouncement2 } from "images";
import Button from "components/Button";
import { NavigateFunction, useNavigate } from "react-router-dom";
import i18n from "i18n";
import { AnalyticsEvent } from "utils";
import { PhotoshootType } from "pages/PhotoshootPage/constants";
import { useSiteImageResolver } from "hooks/useSiteImage";

export const features = [
  {
    titleKey: "common:header.whats_new.features.sketch_to_design.title",
    image: ImageFeatureAnnouncement1,
    imageSlot: "campaign.feature_announcement_1",
    description: () => (
      <span className="text-bodyMd">
        <Trans i18nKey="common:header.whats_new.features.sketch_to_design.description" components={{ highlight: <span className="text-purpleGreen" /> }} />
      </span>
    ),
    button: ({ navigateFunc, callback, fromBanner }: { navigateFunc: NavigateFunction; callback?: () => void; fromBanner: boolean }) => (
      <Button
        className="btn-primary text-trueBlack"
        onClick={() => {
          if (fromBanner) AnalyticsEvent("New_Feature_Pop_up", "", "click");

          navigateFunc("/design");
          if (callback) callback();
        }}
      >
        {i18n.t("common:header.whats_new.try_now")}
      </Button>
    ),
  },
  {
    titleKey: "common:header.whats_new.features.mannequin_photoshoot.title",
    image: ImageFeatureAnnouncement2,
    imageSlot: "campaign.feature_announcement_2",
    description: () => (
      <span className="text-bodyMd">
        <Trans i18nKey="common:header.whats_new.features.mannequin_photoshoot.description" components={{ highlight: <span className="text-purpleGreen" /> }} />
      </span>
    ),
    button: ({ navigateFunc, callback, fromBanner }: { navigateFunc: NavigateFunction; callback?: () => void; fromBanner: boolean }) => (
      <Button
        className="btn-primary text-trueBlack"
        onClick={() => {
          if (fromBanner) AnalyticsEvent("New_Feature_Pop_up", "", "click");

          navigateFunc("/photoshoot", { state: { photoshootType: PhotoshootType.Mannequin } });
          if (callback) callback();
        }}
      >
        {i18n.t("common:header.whats_new.try_now")}
      </Button>
    ),
  },
];

const WhatsNew = ({ show, onClose }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const resolveSiteImage = useSiteImageResolver();

  const FeatureItem = ({ titleKey, description, image, button }: any) => {
    return (
      <div className="flex flex-col gap-3 p-3 border border-black-300 rounded">
        <div className="">
          <img src={image} className="" />
        </div>

        <div className="flex items-center justify-between">
          <h6 className="text-h6 text-white">{t(titleKey)}</h6>
        </div>

        <span className="text-bodySm text-grey">{description()}</span>

        {button && button({ navigateFunc: navigate })}
      </div>
    );
  };

  return (
    <div
      className="bg-black-100 border-l border-black-300  no-scrollbar"
      style={{
        position: "absolute",
        height: "calc(100vh - 86px)",
        width: "320px",
        top: "86px",
        right: 0,
        // transform: `translateX(${show ? "0" : "100%"})`,
        // transition: "transform 0.3s ease-in-out",
        overflowY: "auto",
        visibility: show ? "visible" : "hidden",
      }}
    >
      <div className="flex justify-between items-center p-2 bg-black">
        <span className="text-headline uppercase text-white">{t("common:header.whats_new.title")}</span>
        <IconClose className="cursor-pointer text-white w-[14px] h-[14px]" onClick={onClose} />
      </div>

      <div className="flex flex-col p-2.5 gap-4">
        {features.map((item, index) => (
          <FeatureItem key={index} {...item} image={resolveSiteImage(item.imageSlot, item.image)} />
        ))}
      </div>
    </div>
  );
};

export default WhatsNew;
